// Decimal-safe money helpers. All wallet amounts are integer cents (USD).

/** Parses a decimal string like "40.0" / "25" / "12.50" into cents. Rejects anything else. */
export function decimalToCents(s: string): number {
  const m = /^(\d+)(?:\.(\d{1,2})\d*)?$/.exec(String(s).trim());
  if (!m) throw new Error(`Invalid money amount: ${s}`);
  // Only allow trailing zeros beyond 2 decimals ("40.000" ok, "40.005" not).
  const frac = String(s).trim().split('.')[1] ?? '';
  if (frac.length > 2 && /[1-9]/.test(frac.slice(2))) throw new Error(`Sub-cent amount: ${s}`);
  return parseInt(m[1], 10) * 100 + parseInt((m[2] ?? '').padEnd(2, '0') || '0', 10);
}

/** Cents → "40.00" (what Shopify MoneyInput and Tranzila amounts take). */
export function centsToDecimal(cents: number): string {
  if (!Number.isInteger(cents) || cents < 0) throw new Error(`Invalid cents: ${cents}`);
  return `${Math.floor(cents / 100)}.${String(cents % 100).padStart(2, '0')}`;
}

export function formatUsdCents(cents: number): string {
  return `$${centsToDecimal(cents)}`;
}
